import styled from "styled-components";

const IntegrationsPageStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-row-gap: 25px;
  grid-column-gap: 25px;
`;

const IntegrationLogoWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  flex: 1;
`;
const IntegrationItemStyled = styled.div`
position:relative;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  transition: box-shadow 200ms, transform 200ms;
  :hover {
    /* border-color: #1890ff; */
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07);
    transform: translateY(-5px);
  }
`;

const IntegrationItemLabelStyled = styled.div`
  padding: 10px 20px;
  background: whitesmoke;
  border-top: 1px solid #e5e5e5;
  line-height: 34px;
`;
export {
  IntegrationsPageStyled,
  IntegrationLogoWrapperStyled,
  IntegrationItemStyled,
  IntegrationItemLabelStyled
};
